import { withQueryParams } from '$lib/components/link/with-query-params.svelte';

/** Get the path to redirect to after changing orgs, if a redirect is wanted. */
export const getChangeOrgRedirect = (
  nextOrgID: string,
  currentPath: string
): string | undefined => {
  if (currentPath.startsWith('/login-method-denied')) {
    return withQueryParams(`/fleet`, { org: nextOrgID });
  }

  if (currentPath.startsWith('/fleet/location')) {
    return withQueryParams(`/fleet/locations`, { org: nextOrgID });
  }

  if (currentPath.startsWith('/fleet/machines')) {
    return withQueryParams(`/fleet/machines`, { org: nextOrgID });
  }

  // Preserve the active modules tab when the org changes. Check the more
  // specific subroute first since `/fleet/modules` is a prefix of it.
  if (currentPath.startsWith('/fleet/modules/in-use')) {
    return withQueryParams(`/fleet/modules/in-use`, { org: nextOrgID });
  }
  if (currentPath.startsWith('/fleet/modules')) {
    return withQueryParams(`/fleet/modules`, { org: nextOrgID });
  }

  // if looking at an inline module editor, redirect back to module mgmt page
  if (currentPath.startsWith('/inline-modules/')) {
    return withQueryParams(`/fleet/modules`, { org: nextOrgID });
  }

  if (currentPath.startsWith('/machine/') || currentPath.startsWith('/fleet')) {
    return withQueryParams(`/fleet`, { org: nextOrgID });
  }

  if (currentPath.startsWith('/fragment/')) {
    return withQueryParams(`/fragments`, { org: nextOrgID });
  }

  if (/^\/(?:module|ml-model|ml-training)\//u.test(currentPath)) {
    return withQueryParams(`/registry`, { org: nextOrgID });
  }

  if (currentPath.startsWith('/organization/')) {
    return withQueryParams(`/organization/${nextOrgID}/settings`, {
      org: nextOrgID,
    });
  }

  if (currentPath.startsWith('/models')) {
    return withQueryParams(`/models`, { org: nextOrgID });
  }

  if (currentPath.startsWith('/datasets')) {
    return withQueryParams(`/datasets`, { org: nextOrgID });
  }

  return undefined;
};

/** Get the path to redirect to after creating an org. */
export const getCreateOrgRedirect = (
  nextOrgID: string | undefined
): string | undefined => {
  if (nextOrgID !== undefined) {
    return withQueryParams(`/organization/${nextOrgID}/settings`, {
      org: nextOrgID,
    });
  }

  return undefined;
};
